<template>
  <a
    v-if="current_profile && current_profile.type !== PROFILE_TYPES.EMPLOYEE && !is_notifications_sidebar_open"
    data-test="sidebar-notifications-user"
    @click="toggleSidebar"
  >
    <OverlayBadge
      v-if="show_notification_point"
      class="mr-3"
      data-test="notifications-number"
      severity="danger"
      size="small"
    >
      <span class="notification-bell cursor-pointer rounded-full text-gray-500 md:bg-gray-200 md:p-3 md:shadow-md">
        <FontAwesomeIcon
          :icon="['far', 'bell']"
          size="lg"
        />
      </span>
    </OverlayBadge>
    <div v-else>
      <span class="notification-bell cursor-pointer rounded-full text-gray-500 md:bg-gray-200 md:p-3 md:shadow-md">
        <FontAwesomeIcon
          :icon="['far', 'bell']"
          size="lg"
        />
      </span>
    </div>
  </a>
  <div
    v-else-if="!is_notifications_sidebar_open"
    data-test="sidebar-notifications-user"
  >
    <a
      v-tooltip.bottom="$t('notification.title')"
      :class="[
        'flex cursor-pointer items-center justify-center text-neutral-500',
        variant === 'bare'
          ? ''
          : 'size-8 rounded-full transition-colors duration-150 hover:bg-primary-100 hover:text-neutral-800',
      ]"
      @click="toggleSidebar"
    >
      <OverlayBadge
        v-if="show_notification_point"
        data-test="notifications-number"
        severity="danger"
        size="small"
      >
        <FontAwesomeIcon :icon="['far', 'bell']" />
      </OverlayBadge>
      <FontAwesomeIcon
        v-else
        :icon="['far', 'bell']"
        data-test="notifications-number"
      />
    </a>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { PROFILE_TYPES } from '@/app/data/model_constants';
import SIDEBAR_NOTIFICATIONS from '@/app/data/sidebar_constants';

defineProps({
  variant: { type: String, default: 'default' }, // 'default' | 'bare'
});

const store = useStore();

const current_profile = computed(() => store.getters.current_profile);
const notifications_sidebar_last_opened_at = computed(() => store.getters.notifications_sidebar_last_opened_at);
const sidebar_type = computed(() => store.getters.sidebar_type);

onMounted(() => {
  store.dispatch('INIT_NOTIFICATIONS_LAST_OPENED');
});

const is_notifications_sidebar_open = computed(() => sidebar_type.value === SIDEBAR_NOTIFICATIONS);

const show_notification_point = computed(() => {
  const notified_at = _.get(current_profile.value, 'attributes.notified_at', new Date(0).toISOString());
  return notified_at > notifications_sidebar_last_opened_at.value;
});

const toggleSidebar = () => {
  if (sidebar_type.value === SIDEBAR_NOTIFICATIONS) {
    store.dispatch('SHOW_SIDEBAR', null);
  } else {
    store.dispatch('SHOW_SIDEBAR', SIDEBAR_NOTIFICATIONS);
  }
};
</script>

<style>
/* Pull the overlay badge inward so it sits over the bell icon */
.p-overlaybadge .p-badge {
  transform: translate(-85%, 85%);
}

.notification-bell {
  transition: transform 0.2s ease-in-out;
}

.notification-bell:hover {
  animation: wiggle 0.5s ease-in-out;
}

@keyframes wiggle {
  0%,
  100% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(-5deg);
  }

  75% {
    transform: rotate(5deg);
  }
}
</style>
